export default "__VITE_ASSET__DKA$p2Jj__"